import { createSelector } from '@reduxjs/toolkit';
import { RootStateType } from 'App/ReduxProvider/store';

export const getBackLink = createSelector(
  (state: RootStateType) => state.backLink,
  (backLink) => backLink,
);
